import React from 'react';
import './Error.css'; 
function SubmitErrorOptout() {
  return (
    <div className="submit_error wrapper" >
      <h1>入力されたメールアドレスは、既にメルマガ配信停止されているか、配信の対象ではありません。</h1> 
      <div>
        <h3>入力されたメールアドレスが正しいかどうかお確かめください。</h3>
        <h3>なお、退会を希望する場合は、"らくらく連絡網を退会する"にチェックを入れ、もう一度お試しください。</h3>
        <h3>※システム上、配信停止手続後、１週間ほどはメルマガが届く可能性がございますので、ご了承くださいませ。</h3>
      </div>
      <div className='error_h4'>
        <h4>らくらく連絡網カスタマーサポート：ra9-cs@eu-phoria.jp</h4>
      </div>
    </div>
  );
}
export default SubmitErrorOptout;